const related = {
  // ===== Common (page copy moved to src/data/related/en.ts on 2026-09-18) =====
  'related.common.official': 'Visit the official site',
  'related.common.externalNote': 'External site, opens in a new window',
  'related.common.backToHub': 'Back to all related organizations',
  'related.common.backToTop': 'Back to top',
  'related.common.otherTitle': 'Other related organizations',
  'related.common.otherSubtitleEn': 'Explore the group',
};

export default related;
